import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { TimerSVG } from '@common_components/svg/timer.svg';

const TimerIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <TimerSVG/>
    </div>
  );
};

export { TimerIcon };
